module.exports = __webpack_public_path__ + "static/img/ico_first_place.b86c37e6.png";